import { Route } from 'react-router-dom';
import React from 'react';

export const RouteWithLayout = ({ layout, component, ...rest }: any) => {
  // @ts-ignore
  return <Route {...rest} render={(props: any) => React.createElement(layout, props, React.createElement(component, props))} />;
};
